export const PHRASES_GENERATOR_MIN_GROUPS = 2;
export const PHRASES_GENERATOR_MAX_GROUPS = 7;
export const PHRASES_GENERATOR_MAX_PHRASES = 1000;
export const PHRASES_GENERATOR_DIVIDERS = ',;';
export const PHRASES_GENERATOR_NEW_LINE_WITH_SPACES_REGEXP = /\s*\n\s*/g;
export const PHRASES_GENERATOR_EMPTY_PHRASE_SYMBOLS = '*';
export const PHRASES_SELECTOR_MAX_NESTED_CHILDREN = 400;
export const PHRASES_SELECTOR_SPACE_SYMBOLS_REGEXP = /\s+/g;

export const PHRASES_SELECTOR_START_PHRASES_MIN_WIDTH = 550;
export const PHRASES_SELECTOR_KEYWORDS_MIN_WIDTH = 265;
export const PHRASES_SELECTOR_SELECTED_PHRASES_MIN_WIDTH = 485;
